import _ from 'lodash';
import {createSelector} from 'reselect';

import {findCardForContactInNamespace} from '../../../helpers/models/contactHelpers';
import {AppParametricSelector} from '../../../helpers/reselectHelpers';
import {CompanyContactsScopeValuesEnum} from '../../../models/api/companyPreferencesModel';
import {getHasCompanyCards} from '../../featureFlags/featureFlagsSelectors';
import {getCompanyContactsScope} from '../company/companySelectors';
import {getCards, getContacts} from '../dataSelectors';

export const getHasCompanyCardsEnabled = createSelector(
  [getHasCompanyCards, getCompanyContactsScope],
  (hasCompanyCards, companyContactsScope) =>
    // We want to show company cards if the feature flag is on or if the company's preference is enabled
    hasCompanyCards || companyContactsScope === CompanyContactsScopeValuesEnum.READ_WRITE,
);

export const makeGetCardForHandle = (handle: string, namespace: string) =>
  createSelector([getContacts, getCards], (contacts, cards) => {
    const existingContact = Object.values(contacts).find((c) => c?.handle === handle);

    if (!existingContact) {
      return undefined;
    }

    return findCardForContactInNamespace(existingContact, cards, namespace);
  });

export function makeGetCard(getCardId: AppParametricSelector<any, number | undefined>) {
  return createSelector([getCardId, getCards], (cardId, cards) => {
    if (!cardId) {
      return undefined;
    }
    return cards[cardId];
  });
}

export function makeGetCards(getCardIds: AppParametricSelector<any, ReadonlyArray<number> | undefined>) {
  return createSelector([getCards, getCardIds], (cards, cardIds) =>
    _(cardIds ?? [])
      .map((cardId) => cards[cardId])
      .compact()
      .value(),
  );
}
